/**
 * API client for the backend logging endpoints.
 *
 * Uses raw fetch instead of ApiCaller to prevent re-entrancy:
 * ApiCaller.handleApiResponse calls console.error on failure (line 100),
 * which would re-enter the console override and risk infinite loops.
 */

import { FrontendLogEntry } from 'types/logging';

const BASE_URL = '/Api/Logging';

export class LoggingApi {

    public static TrackLogs = (entries: FrontendLogEntry[]): Promise<void> => fetch(`${BASE_URL}/TrackLogs`, {
        body: JSON.stringify({ entries }),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST'
    }).then(() => undefined);

    public static TrackException = (
        message: string,
        stack: string,
        componentStack: string,
        url: string
    ): Promise<void> => fetch(`${BASE_URL}/TrackException`, {
        body: JSON.stringify({ componentStack, message, stack, url }),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST'
    }).then(response => {

        if (!response.ok) {

            throw new Error(`TrackException failed: ${response.status} ${response.statusText}`);

        }

    });

}
